<template>
  <div v-if="showAlert" class="impersonation-alert-wrapper">
    <b-alert
      show
      variant="warning"
      class="impersonation-alert mb-0"
      dismissible
      @dismissed="stopImpersonation"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <i class="fa fa-user-secret me-2"></i>
          <span>
            <strong>Suplantando a:</strong> {{ impersonatedUser.name }} ({{ impersonatedUser.email }})
          </span>
        </div>
        <b-button
          variant="outline-dark"
          size="sm"
          :disabled="processing"
          @click="stopImpersonation"
        >
          <i class="fa fa-sign-out-alt me-1"></i>
          {{ processing ? 'Deteniendo...' : 'Detener Suplantación' }}
        </b-button>
      </div>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'ImpersonationAlert',
  data () {
    return {
      showAlert: false,
      impersonatedUser: {
        name: '',
        surname: '',
        email: ''
      },
      processing: false
    }
  },
  mounted () {
    this.startWatching()
  },

  beforeDestroy () {
    this.stopWatching()
  },
  methods: {
    startWatching () {
      this.checkImpersonationStatus()
      // Check for changes every second to detect new impersonation sessions
      this.checkInterval = setInterval(() => {
        this.checkImpersonationStatus()
      }, 1000)
    },

    stopWatching () {
      if (this.checkInterval) {
        clearInterval(this.checkInterval)
      }
    },

    checkImpersonationStatus () {
      const impersonationData = localStorage.getItem('impersonationData')

      if (impersonationData) {
        try {
          const data = JSON.parse(impersonationData)
          this.impersonatedUser = data.impersonatedUser
          this.showAlert = true
        } catch (error) {
          console.error('Error parsing impersonation data:', error)
          this.clearImpersonationData()
        }
      } else {
        this.showAlert = false
        this.impersonatedUser = { name: '', surname: '', email: '' }
      }
    },

    async stopImpersonation () {
      try {
        this.processing = true

        // Get the original token from stored data
        const impersonationData = localStorage.getItem('impersonationData')

        if (impersonationData) {
          const data = JSON.parse(impersonationData)

          // Restore the original access token
          localStorage.setItem('accessToken', data.originalToken)

          // Clear impersonation data
          this.clearImpersonationData()

          // Reload desktop parameter config to restore admin's original data
          await this.$store.dispatch('fetchDesktopParameterConfig')

          // Show success message
          this.$bvToast.toast('La suplantación se ha detenido correctamente', {
            title: 'Suplantación Detenida',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000
          })

          // Route back to user management
          this.$router.push({ name: 'usersManagement' })
        }
      } catch (error) {
        console.error('Error stopping impersonation:', error)
        this.$bvToast.toast('Error al detener la suplantación', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        })
      } finally {
        this.processing = false
      }
    },

    clearImpersonationData () {
      localStorage.removeItem('impersonationData')
      this.showAlert = false
      this.impersonatedUser = { name: '', surname: '', email: '' }
    }
  }
}
</script>

<style scoped>
.impersonation-alert-wrapper {
  /* Remove fixed positioning - let it be inline */
  padding: 0;
  margin: 0;
}

.impersonation-alert {
  background: linear-gradient(135deg, #ff8c00 0%, #ff6b35 100%);
  color: white;
  border-radius: 0;
  border: none;
  padding: 0.75rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.impersonation-alert .d-flex {
  align-items: center;
}

.impersonation-alert .me-2 {
  font-size: 1.25rem;
}

.impersonation-alert .fa-sign-out-alt {
  font-size: 0.9rem;
}

.impersonation-alert .btn-outline-dark {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-size: 0.8rem;
  padding: 0.25rem 0.75rem;
  transition: all 0.3s ease;
  border-radius: 4px;
  font-weight: 500;
}

.impersonation-alert .btn-outline-dark:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: white;
  transform: translateY(-1px);
}

.impersonation-alert .btn-outline-dark:disabled {
  opacity: 0.7;
  transform: none;
}

@media (max-width: 768px) {
  .impersonation-alert-wrapper {
    padding: 0.75rem 1rem;
  }

  .impersonation-alert .d-flex {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }

  .impersonation-alert .btn-outline-dark {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/shared/components/ImpersonationAlert.vue